import { render, staticRenderFns } from "./MobileAgendaBlock.vue?vue&type=template&id=68323ed6&"
import script from "./MobileAgendaBlock.vue?vue&type=script&lang=js&"
export * from "./MobileAgendaBlock.vue?vue&type=script&lang=js&"
import style0 from "./MobileAgendaBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
